<div class="reports-center-page">
  <div class="reports-center-page__hero">
    <div>
      <h1>מרכז דוחות</h1>
      <p>גישה שקטה, מסודרת ומהירה לדוחות הקיימים, עם סינונים ובחירת עמודות לפני הורדה.</p>
    </div>
  </div>

  <div class="reports-center-page__grid">
    <button type="button" class="reports-center-card" *ngFor="let report of reports" (click)="openReport(report)">
      <div class="reports-center-card__icon">
        <i class="fa" [ngClass]="report.icon"></i>
      </div>
      <div class="reports-center-card__body">
        <h2>{{ report.title }}</h2>
        <p>{{ report.description }}</p>
      </div>
      <div class="reports-center-card__action">
        <span>פתח דוח</span>
        <i class="fa fa-angle-left"></i>
      </div>
    </button>
  </div>
</div>
